import { i18n } from '../plugins/i18n'
import { camelCase } from './string_converter'

const paymentMethodCategories = ['creditCards', 'qrCodePayments', 'electronicMoneys', 'transportationElectronicMoneys', 'otherPayments']

export const translatePaymentMethod = (method: string): string => {
  // 交通系電子決済を包括した表現で返す
  if (method === 'transportationElectronicMoney') return i18n.t('models.storePaymentMethod.transportationElectronicMoneys.unify')

  for(const category of paymentMethodCategories) {
    const key = `models.storePaymentMethod.${category}.${method}`
    if (i18n.te(key)) return i18n.t(key)
  }
  return ''
}

export const translatePaymentMethods = (methods: string[]): string[] => {
  return methods.map(method => camelCase(method)).map(method => translatePaymentMethod(method))
}
